module.exports = __webpack_public_path__ + "static/b5-04d04e445f890ef0204d245430d7d4d2.jpg";